"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FieldHandler", {
    enumerable: true,
    get: function() {
        return FieldHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _currencygeneralhandler = require("./handlers/currency/currency.general.handler");
const _currencypghandler = require("./handlers/currency/currency.pg.handler");
const _currencymysqlhandler = require("./handlers/currency/currency.mysql.handler");
const _currencysqlitehandler = require("./handlers/currency/currency.sqlite.handler");
const _catchError = require("~/helpers/catchError");
const _jsongeneralhandler = require("~/db/field-handler/handlers/json/json.general.handler");
const _generic = require("~/db/field-handler/handlers/generic");
const _checkboxgeneralhandler = require("~/db/field-handler/handlers/checkbox/checkbox.general.handler");
const _datetimegeneralhandler = require("~/db/field-handler/handlers/date-time/date-time.general.handler");
const _dategeneralhandler = require("~/db/field-handler/handlers/date/date.general.handler");
const _multiselectgeneralhandler = require("~/db/field-handler/handlers/multi-select/multi-select.general.handler");
const _singleselectgeneralhandler = require("~/db/field-handler/handlers/single-select/single-select.general.handler");
const _decimalgeneralhandler = require("~/db/field-handler/handlers/decimal/decimal.general.handler");
const _numbergeneralhandler = require("~/db/field-handler/handlers/number/number.general.handler");
const _formulageneralhandler = require("~/db/field-handler/handlers/formula/formula.general.handler");
const _jsonmysqlhandler = require("~/db/field-handler/handlers/json/json.mysql.handler");
const _ltargeneralhandler = require("~/db/field-handler/handlers/ltar/ltar.general.handler");
const _lookupgeneralhandler = require("~/db/field-handler/handlers/lookup/lookup.general.handler");
const _linksgeneralhandler = require("~/db/field-handler/handlers/links/links.general.handler");
const _rollupgeneralhandler = require("~/db/field-handler/handlers/rollup/rollup.general.handler");
const _percentgeneralhandler = require("~/db/field-handler/handlers/percent/percent.general.handler");
const _ratinggeneralhandler = require("~/db/field-handler/handlers/rating/rating.general.handler");
const _yeargeneralhandler = require("~/db/field-handler/handlers/year/year.general.handler");
const _usergeneralhandler = require("~/db/field-handler/handlers/user/user.general.handler");
const _durationgeneralhandler = require("~/db/field-handler/handlers/duration/duration.general.handler");
const _checkboxsqlitehandler = require("~/db/field-handler/handlers/checkbox/checkbox.sqlite.handler");
const _longtextgeneralhandler = require("~/db/field-handler/handlers/long-text/long-text.general.handler");
const _singlelinetextgeneralhandler = require("~/db/field-handler/handlers/single-line-text/single-line-text.general.handler");
const _computed = require("~/db/field-handler/handlers/computed");
const _datetimesqlitehandler = require("~/db/field-handler/handlers/date-time/date-time.sqlite.handler");
const _datetimemysqlhandler = require("~/db/field-handler/handlers/date-time/date-time.mysql.handler");
const _datetimepghandler = require("~/db/field-handler/handlers/date-time/date-time.pg.handler");
const _decimalmysqlhandler = require("~/db/field-handler/handlers/decimal/decimal.mysql.handler");
const _decimalsqlitehandler = require("~/db/field-handler/handlers/decimal/decimal.sqlite.handler");
const _numberpghandler = require("~/db/field-handler/handlers/number/number.pg.handler");
const _numbermysqlhandler = require("~/db/field-handler/handlers/number/number.mysql.handler");
const _numbersqlitehandler = require("~/db/field-handler/handlers/number/number.sqlite.handler");
const _ratingmysqlhandler = require("~/db/field-handler/handlers/rating/rating.mysql.handler");
const _ratingpghandler = require("~/db/field-handler/handlers/rating/rating.pg.handler");
const _ratingsqlitehandler = require("~/db/field-handler/handlers/rating/rating.sqlite.handler");
const _colourgeneralhandler = require("~/db/field-handler/handlers/colour/colour.general.handler");
const _percentmysqlhandler = require("~/db/field-handler/handlers/percent/percent.mysql.handler");
const _percentpghandler = require("~/db/field-handler/handlers/percent/percent.pg.handler");
const _percentsqlitehandler = require("~/db/field-handler/handlers/percent/percent.sqlite.handler");
const _userpghandler = require("~/db/field-handler/handlers/user/user.pg.handler");
const _usersqlitehandler = require("~/db/field-handler/handlers/user/user.sqlite.handler");
const _phonenumbergeneralhandler = require("~/db/field-handler/handlers/phone-number/phone-number.general.handler");
const _models = require("~/models");
const _jsonpghandler = require("~/db/field-handler/handlers/json/json.pg.handler");
const _decimalpghandler = require("~/db/field-handler/handlers/decimal/decimal.pg.handler");
const _emailgeneralhandler = require("~/db/field-handler/handlers/email/email.general.handler");
const _attachmentgeneralhandler = require("~/db/field-handler/handlers/attachment/attachment.general.handler");
const _timegeneralhandler = require("~/db/field-handler/handlers/time/time.general.handler");
const _timemysqlhandler = require("~/db/field-handler/handlers/time/time.mysql.handler");
const _uuidpghandler = require("~/db/field-handler/handlers/uuid/uuid.pg.handler");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CLIENT_DEFAULT = '_default';
const HANDLER_REGISTRY = {
    [_nocodbsdk.UITypes.ID]: {
        [CLIENT_DEFAULT]: _generic.GenericFieldHandler
    },
    [_nocodbsdk.UITypes.LinkToAnotherRecord]: {
        [CLIENT_DEFAULT]: _ltargeneralhandler.LtarGeneralHandler
    },
    [_nocodbsdk.UITypes.ForeignKey]: {},
    [_nocodbsdk.UITypes.Lookup]: {
        [CLIENT_DEFAULT]: _lookupgeneralhandler.LookupGeneralHandler
    },
    [_nocodbsdk.UITypes.SingleLineText]: {
        [CLIENT_DEFAULT]: _singlelinetextgeneralhandler.SingleLineTextGeneralHandler
    },
    [_nocodbsdk.UITypes.LongText]: {
        [CLIENT_DEFAULT]: _longtextgeneralhandler.LongTextGeneralHandler
    },
    [_nocodbsdk.UITypes.Attachment]: {
        [CLIENT_DEFAULT]: _attachmentgeneralhandler.AttachmentGeneralHandler
    },
    [_nocodbsdk.UITypes.Checkbox]: {
        [CLIENT_DEFAULT]: _checkboxgeneralhandler.CheckboxGeneralHandler,
        [_nocodbsdk.ClientType.SQLITE]: _checkboxsqlitehandler.CheckboxSqliteHandler
    },
    [_nocodbsdk.UITypes.MultiSelect]: {
        [CLIENT_DEFAULT]: _multiselectgeneralhandler.MultiSelectGeneralHandler
    },
    [_nocodbsdk.UITypes.SingleSelect]: {
        [CLIENT_DEFAULT]: _singleselectgeneralhandler.SingleSelectGeneralHandler
    },
    [_nocodbsdk.UITypes.Date]: {
        [CLIENT_DEFAULT]: _dategeneralhandler.DateGeneralHandler
    },
    [_nocodbsdk.UITypes.Year]: {
        [CLIENT_DEFAULT]: _yeargeneralhandler.YearGeneralHandler
    },
    [_nocodbsdk.UITypes.Time]: {
        [CLIENT_DEFAULT]: _timegeneralhandler.TimeGeneralHandler,
        [_nocodbsdk.ClientType.MYSQL]: _timemysqlhandler.TimeMysqlHandler
    },
    [_nocodbsdk.UITypes.PhoneNumber]: {
        [CLIENT_DEFAULT]: _phonenumbergeneralhandler.PhoneNumberGeneralHandler
    },
    [_nocodbsdk.UITypes.GeoData]: {},
    [_nocodbsdk.UITypes.Email]: {
        [CLIENT_DEFAULT]: _emailgeneralhandler.EmailGeneralHandler
    },
    [_nocodbsdk.UITypes.URL]: {
        [CLIENT_DEFAULT]: _generic.GenericFieldHandler
    },
    [_nocodbsdk.UITypes.UUID]: {
        [CLIENT_DEFAULT]: _generic.GenericFieldHandler,
        [_nocodbsdk.ClientType.PG]: _uuidpghandler.UuidPgHandler
    },
    [_nocodbsdk.UITypes.Number]: {
        [CLIENT_DEFAULT]: _numbergeneralhandler.NumberGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _numberpghandler.NumberPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _numbermysqlhandler.NumberMysqlHandler,
        [_nocodbsdk.ClientType.SQLITE]: _numbersqlitehandler.NumberSqliteHandler
    },
    [_nocodbsdk.UITypes.Decimal]: {
        [CLIENT_DEFAULT]: _decimalgeneralhandler.DecimalGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _decimalpghandler.DecimalPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _decimalmysqlhandler.DecimalMysqlHandler,
        [_nocodbsdk.ClientType.SQLITE]: _decimalsqlitehandler.DecimalSqliteHandler
    },
    [_nocodbsdk.UITypes.Currency]: {
        [CLIENT_DEFAULT]: _currencygeneralhandler.CurrencyGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _currencypghandler.CurrencyPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _currencymysqlhandler.CurrencyMysqlHandler,
        [_nocodbsdk.ClientType.SQLITE]: _currencysqlitehandler.CurrencySqliteHandler
    },
    [_nocodbsdk.UITypes.Percent]: {
        [CLIENT_DEFAULT]: _percentgeneralhandler.PercentGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _percentpghandler.PercentPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _percentmysqlhandler.PercentMysqlHandler,
        [_nocodbsdk.ClientType.SQLITE]: _percentsqlitehandler.PercentSqliteHandler
    },
    [_nocodbsdk.UITypes.Duration]: {
        [CLIENT_DEFAULT]: _durationgeneralhandler.DurationGeneralHandler
    },
    [_nocodbsdk.UITypes.Rating]: {
        [CLIENT_DEFAULT]: _ratinggeneralhandler.RatingGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _ratingpghandler.RatingPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _ratingmysqlhandler.RatingMysqlHandler,
        [_nocodbsdk.ClientType.SQLITE]: _ratingsqlitehandler.RatingSqliteHandler
    },
    [_nocodbsdk.UITypes.Colour]: {
        [CLIENT_DEFAULT]: _colourgeneralhandler.ColourGeneralHandler
    },
    [_nocodbsdk.UITypes.Formula]: {
        [CLIENT_DEFAULT]: _formulageneralhandler.FormulaGeneralHandler
    },
    [_nocodbsdk.UITypes.Rollup]: {
        [CLIENT_DEFAULT]: _rollupgeneralhandler.RollupGeneralHandler
    },
    [_nocodbsdk.UITypes.DateTime]: {
        [CLIENT_DEFAULT]: _datetimegeneralhandler.DateTimeGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _datetimepghandler.DateTimePGHandler,
        [_nocodbsdk.ClientType.MYSQL]: _datetimemysqlhandler.DateTimeMySQLHandler,
        [_nocodbsdk.ClientType.SQLITE]: _datetimesqlitehandler.DateTimeSQLiteHandler
    },
    [_nocodbsdk.UITypes.CreatedTime]: {
        [CLIENT_DEFAULT]: _datetimegeneralhandler.DateTimeGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _datetimepghandler.DateTimePGHandler,
        [_nocodbsdk.ClientType.MYSQL]: _datetimemysqlhandler.DateTimeMySQLHandler,
        [_nocodbsdk.ClientType.SQLITE]: _datetimesqlitehandler.DateTimeSQLiteHandler
    },
    [_nocodbsdk.UITypes.LastModifiedTime]: {
        [CLIENT_DEFAULT]: _datetimegeneralhandler.DateTimeGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _datetimepghandler.DateTimePGHandler,
        [_nocodbsdk.ClientType.MYSQL]: _datetimemysqlhandler.DateTimeMySQLHandler,
        [_nocodbsdk.ClientType.SQLITE]: _datetimesqlitehandler.DateTimeSQLiteHandler
    },
    [_nocodbsdk.UITypes.AutoNumber]: {},
    [_nocodbsdk.UITypes.Geometry]: {},
    [_nocodbsdk.UITypes.JSON]: {
        [_nocodbsdk.ClientType.PG]: _jsonpghandler.JsonPgHandler,
        [_nocodbsdk.ClientType.MYSQL]: _jsonmysqlhandler.JsonMySqlHandler,
        [CLIENT_DEFAULT]: _jsongeneralhandler.JsonGeneralHandler
    },
    [_nocodbsdk.UITypes.SpecificDBType]: {},
    [_nocodbsdk.UITypes.Barcode]: {
        [CLIENT_DEFAULT]: _computed.ComputedFieldHandler
    },
    [_nocodbsdk.UITypes.QrCode]: {
        [CLIENT_DEFAULT]: _computed.ComputedFieldHandler
    },
    [_nocodbsdk.UITypes.Button]: {
        [CLIENT_DEFAULT]: _computed.ComputedFieldHandler
    },
    [_nocodbsdk.UITypes.Links]: {
        [CLIENT_DEFAULT]: _linksgeneralhandler.LinksGeneralHandler
    },
    [_nocodbsdk.UITypes.User]: {
        [CLIENT_DEFAULT]: _usergeneralhandler.UserGeneralHandler,
        [_nocodbsdk.ClientType.PG]: _userpghandler.UserPgHandler,
        [_nocodbsdk.ClientType.SQLITE]: _usersqlitehandler.UserSqliteHandler
    },
    [_nocodbsdk.UITypes.CreatedBy]: {
        [CLIENT_DEFAULT]: _computed.ComputedFieldHandler
    },
    [_nocodbsdk.UITypes.LastModifiedBy]: {
        [CLIENT_DEFAULT]: _computed.ComputedFieldHandler
    }
};
function getLogicalOpMethod(logical_op) {
    switch(logical_op == null ? void 0 : logical_op.toLowerCase()){
        case 'or':
            return 'orWhere';
        case 'and':
            return 'andWhere';
        case 'not':
            return 'whereNot';
        default:
            return 'where';
    }
}
let FieldHandler = class FieldHandler {
    static fromBaseModel(baseModel) {
        return new FieldHandler({
            context: baseModel.context,
            baseModel: baseModel,
            knex: baseModel.dbDriver
        });
    }
    /**
   * Retrieves the appropriate FieldHandler instance based on UI type and database client.
   * @param uiType - The UI type of the column (e.g., UITypes.Date).
   * @param dbClient - The database client type (e.g., 'pg').
   * @returns An instance of the corresponding FieldHandler.
   * @throws Error if no handler is registered.
   */ getHandler(uiType, dbClient) {
        var _ref;
        const dbHandlers = HANDLER_REGISTRY[uiType];
        const HandlerClass = (_ref = dbHandlers == null ? void 0 : dbHandlers[dbClient]) != null ? _ref : dbHandlers == null ? void 0 : dbHandlers[CLIENT_DEFAULT];
        if (!HandlerClass) {
            return undefined;
        }
        return new HandlerClass();
    }
    /**
   * Applies a filter to the query builder using the appropriate handler.
   * @param qb - Knex query builder instance.
   * @param filter - Filter object
   * @param column - Column object
   * @param knex - Knex instance to determine the database client.
   * @param options - Additional options like alias.
   */ async applyFilter(filter, column, options = {}) {
        var _options_knex, _ref;
        const knex = (_options_knex = options.knex) != null ? _options_knex : this.info.knex;
        const dbClient = (_ref = knex.clientType == null ? void 0 : knex.clientType.call(knex)) != null ? _ref : knex.client.config.client;
        const handler = this.getHandler(column.uidt, dbClient);
        const useColumn = column != null ? column : this.info.baseModel.model.columns.find((col)=>col.id === filter.id);
        return handler.filter(knex, filter, useColumn, _extends({
            knex,
            fieldHandler: this
        }, this.info, options));
    }
    async applyFilterGroup(filter, options = {}) {
        return this.applyFilters(filter.children, options);
    }
    async applyFilters(filters, options = {}) {
        var _ref;
        var _options_baseModel;
        const model = (_ref = (_options_baseModel = options.baseModel) == null ? void 0 : _options_baseModel.model) != null ? _ref : this.info.baseModel.model;
        if (!model.columns) {
            var _options_context;
            await model.getColumns((_options_context = options.context) != null ? _options_context : this.info.context);
        }
        const qbHandlers = [];
        let index = 0;
        for (const filter of filters){
            if (filter.is_group) {
                qbHandlers.push({
                    handler: await this.applyFilterGroup(filter, options),
                    index: index++,
                    logicalOps: filter.logical_op
                });
            } else {
                let column = model.columns.find((col)=>col.id === filter.fk_column_id);
                if (!column) {
                    column = await this.getRelatedColumnById(options.context, filter.fk_column_id);
                }
                qbHandlers.push({
                    handler: await this.applyFilter(filter, column, options),
                    index: index++,
                    logicalOps: filter.logical_op
                });
            }
        }
        return {
            clause: (qb)=>{
                for (const handler of qbHandlers.sort((a, b)=>a.index - b.index)){
                    qb[getLogicalOpMethod(handler.logicalOps)](handler.handler.clause);
                }
            },
            rootApply: (qb)=>{
                for (const handler of qbHandlers.sort((a, b)=>a.index - b.index)){
                    handler.handler.rootApply == null ? void 0 : handler.handler.rootApply.call(handler.handler, qb);
                }
            }
        };
    }
    /**
   * Applies a select operation to the query builder using the appropriate handler.
   * @param qb - Knex query builder instance.
   * @param column - Column object
   * @param knex - Knex instance to determine the database client.
   * @param options - Additional options like alias.
   */ async applySelect(qb, column, options = {}) {
        var _options_knex, _ref;
        const knex = (_options_knex = options.knex) != null ? _options_knex : this.info.knex;
        const dbClient = (_ref = knex.clientType == null ? void 0 : knex.clientType.call(knex)) != null ? _ref : knex.client.config.client;
        const handler = this.getHandler(column.uidt, dbClient);
        return handler.select(qb, column, _extends({
            knex,
            fieldHandler: this
        }, this.info, options));
    }
    async verifyFilter(filter, column, options = {}) {
        var _options_knex, _this_getHandler;
        const knex = (_options_knex = options.knex) != null ? _options_knex : this.info.knex;
        return ((_this_getHandler = this.getHandler(column.uidt, knex.client)) != null ? _this_getHandler : new _generic.GenericFieldHandler()).verifyFilter(filter, column, _extends({
            fieldHandler: this
        }, this.info, options));
    }
    async verifyFiltersSafe(filters, options = {}) {
        var _options_baseModel, _options_context;
        var _invalidFilterResults_errors;
        const baseModel = (_options_baseModel = options.baseModel) != null ? _options_baseModel : this.info.baseModel;
        const context = (_options_context = options.context) != null ? _options_context : this.info.context;
        const model = baseModel.model;
        if (!model.columns) {
            await model.getColumns(context);
        }
        const traverseResult = [];
        await this.traverseFilters(filters, async (filter)=>{
            let column = model.columns.find((col)=>col.id === filter.fk_column_id);
            if (!column) {
                column = await this.getRelatedColumnById(context, filter.fk_column_id);
            }
            traverseResult.push(await this.verifyFilter(filter, column, _extends({}, this.info, options)));
        });
        const invalidFilterResults = traverseResult.filter((k)=>!k.isValid).reduce((obj, res)=>{
            obj.errors = obj.errors.concat(res.errors);
            return obj;
        }, {
            isValid: false,
            errors: []
        });
        if (((_invalidFilterResults_errors = invalidFilterResults.errors) == null ? void 0 : _invalidFilterResults_errors.length) > 0) {
            return invalidFilterResults;
        } else {
            return {
                isValid: true
            };
        }
    }
    async verifyFilters(filters, options = {}) {
        const verificationResult = await this.verifyFiltersSafe(filters, options);
        if (!verificationResult.isValid) {
            _catchError.NcError.get(this.info.context).filterVerificationFailed(verificationResult.errors);
        }
        return true;
    }
    async traverseFilters(filters, handler) {
        return Promise.all((filters != null ? filters : []).map(async (filter)=>{
            // somehow filters is an array of array
            if (Array.isArray(filter)) {
                return this.traverseFilters(filter, handler);
            } else if (filter.is_group) {
                return this.traverseFilters(filter.children, handler);
            } else {
                return handler(filter);
            }
        }));
    }
    async getRelatedColumnById(context, colId) {
        // possibly to be enhanced into getting the model and basemodel too
        const column = await _models.Column.get(context, {
            colId
        });
        return column;
    }
    async parseUserInput(params) {
        var _ref, _ref1;
        var _params_options;
        const baseModel = (_ref = (_params_options = params.options) == null ? void 0 : _params_options.baseModel) != null ? _ref : this.info.baseModel;
        const knex = baseModel.dbDriver;
        const dbClientType = (_ref1 = knex.clientType == null ? void 0 : knex.clientType.call(knex)) != null ? _ref1 : knex.client.config.client;
        const handler = this.getHandler(params.column.uidt, dbClientType);
        if (handler) {
            return handler.parseUserInput(_extends({}, params, {
                options: _extends({
                    baseModel: this.info.baseModel
                }, params.options)
            }));
        } else {
            return {
                value: params.value
            };
        }
    }
    async parseDbValue(params) {
        var _ref, _ref1;
        var _params_options;
        const baseModel = (_ref = (_params_options = params.options) == null ? void 0 : _params_options.baseModel) != null ? _ref : this.info.baseModel;
        const knex = baseModel.dbDriver;
        const dbClientType = (_ref1 = knex.clientType == null ? void 0 : knex.clientType.call(knex)) != null ? _ref1 : knex.client.config.client;
        const handler = this.getHandler(params.column.uidt, dbClientType);
        if (handler) {
            return handler.parseDbValue(_extends({}, params, {
                options: _extends({
                    baseModel: this.info.baseModel
                }, params.options)
            }));
        } else {
            return {
                value: params.value
            };
        }
    }
    async parseDataDbValue(params) {
        var _ref, _ref1, _ref2, _ref3;
        var _params_options, _params_options1, _params_options2;
        const baseModel = (_ref = (_params_options = params.options) == null ? void 0 : _params_options.baseModel) != null ? _ref : this.info.baseModel;
        const context = (_ref1 = (_ref2 = (_params_options1 = params.options) == null ? void 0 : _params_options1.context) != null ? _ref2 : this.info.context) != null ? _ref1 : baseModel.context;
        const knex = baseModel.dbDriver;
        const dbClientType = (_ref3 = knex.clientType == null ? void 0 : knex.clientType.call(knex)) != null ? _ref3 : knex.client.config.client;
        const data = Array.isArray(params.data) ? params.data : [
            params.data
        ];
        for (const column of (await baseModel.model.getColumns(context)).concat(((_params_options2 = params.options) == null ? void 0 : _params_options2.additionalColumns) || [])){
            const handler = this.getHandler(column.uidt, dbClientType);
            if (handler) {
                for (const row of data){
                    if (!(0, _nocodbsdk.ncIsUndefined)(row[column.id])) {
                        row[column.id] = (await handler.parseDbValue({
                            value: row[column.id],
                            row,
                            column,
                            options: _extends({
                                baseModel: this.info.baseModel
                            }, params.options, {
                                fieldHandler: this
                            })
                        })).value;
                    }
                    if (!(0, _nocodbsdk.ncIsUndefined)(row[column.title])) {
                        row[column.title] = (await handler.parseDbValue({
                            value: row[column.title],
                            row,
                            column,
                            options: _extends({
                                baseModel: this.info.baseModel
                            }, params.options, {
                                fieldHandler: this
                            })
                        })).value;
                    } else if ((0, _nocodbsdk.isLookup)(column) || (0, _nocodbsdk.isLinksOrLTAR)(column) || (0, _nocodbsdk.isRollup)(column)) {
                    // const value = (
                    //   await handler.parseDbValue({
                    //     value: row[column.title],
                    //     row,
                    //     baseModel: baseModel,
                    //     column,
                    //     options: { ...params.options, fieldHandler: this },
                    //   })
                    // ).value;
                    // row[column.title] = value;
                    // row[column.id] = value;
                    }
                }
            } else {
                continue;
            }
        }
    }
    constructor(info){
        this.info = info;
    }
};
